module.exports = __webpack_public_path__ + "img/ADSL-Pots-adsl-modem-Splitter-433774.jpg_350x350.0c50c61f.jpg";